export function Loading({ src = "/tim_logo.svg" }: { src?: string }) {
  return (
    <div className="min-w-screen flex min-h-screen items-center justify-center">
      <img src={src} alt="Logo da empresa TIM" className="h-24 animate-pulse" />
    </div>
  );
}
